<template>
    <div v-if="loading" class="loading loading-spinner" />
    <div v-else-if="products" class="flex flex-col gap">
        <div class="hidden sm:block pb-7 text-link w-full text-center font-semibold text-2xl">
            {{ t('product.crossSelling.title') }}
        </div>
        <LazyProductSlider
            :products="products"
            box-layout="minimal"
            :slider-id="content.id"
        />
    </div>

</template>

<script setup lang="ts">
import type { HblProduct, HblSlot } from '@/utils/types'
import { hblDetailData } from '@/utils/helper'
import {inject} from "vue";
import {useEpoq} from "#imports";
import { useI18n } from 'vue-i18n'

const {t} = useI18n()

const props = defineProps<{
    content: HblSlot
}>()

const products: Ref<HblProduct[]|null> = ref(null)
const product = inject<HblProduct>(hblDetailData)

const loading = ref(true)

onMounted(async () => {
    const { getRecommendations } = useEpoq()
    products.value = await getRecommendations('pdpXsell', product?.sku as string)
    loading.value = false
})
</script>
